import React, { useMemo } from 'react';
import { Field, Form as FormikForm, Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import { Redirect } from 'react-router-dom';
import { object, string } from 'yup';

import SubmitWithLoading from '$app-web/components/submit-with-loading';
import { useSendForgotPasswordLinkToEmail } from '$app-web/modules/auth/hooks';
import CustomInputTextField from '$app-web/modules/auth/pages/sign-up/components/custom-input-text-field';
import { getIsACT, URLsManager } from '$app-web/utils';

import useStyles from './styles';

import { FontAwesomeIcon } from '$common/fontawesome-pro/react-fontawesome';

const initialValues = { email: '' };

const validationSchema = object().shape({
    email: string().email().required('You should enter your email address.'),
});

const Form = () => {
    const classes = useStyles();
    const { t } = useTranslation();
    const isACT = useMemo(() => getIsACT(), []);

    const { sendForgotPasswordLinkToEmail, isSuccess, isLoading } = useSendForgotPasswordLinkToEmail();

    if (isSuccess) {
        return <Redirect to={URLsManager.to('dashboard:auth:FORGOT_PASSWORD_SUCCESS')} />;
    }

    return (
        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={sendForgotPasswordLinkToEmail}>
            <FormikForm>
                <div className={classes.root}>
                    <Field
                        name="email"
                        placeholder={t('pdash:email_address')}
                        type="email"
                        component={CustomInputTextField}
                        fullWidth
                        margin="normal"
                        startAdornment={<FontAwesomeIcon icon={['fal', 'envelope']} />}
                        showHelperTextOnError={false}
                    />
                    <div className={classes.submitButtonWrapper}>
                        <SubmitWithLoading
                            classes={{
                                submitButton: isACT ? 'containedACTColor' : undefined,
                            }}
                            text={t('pdash:activity_password_reset_title')}
                            isSubmitting={isLoading}
                            buttonProps={{
                                variant: 'contained',
                                color: 'secondary',
                                fullWidth: true,
                            }}
                        />
                    </div>
                </div>
            </FormikForm>
        </Formik>
    );
};

export default Form;
